import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { DbService } from 'src/app/services/db.service';

@Component({
  selector: 'app-play-loading',
  templateUrl: './play-loading.component.html',
  styleUrls: ['./play-loading.component.css']
})
export class PlayLoadingComponent implements OnInit {

  userId;

  constructor(
    private db: DbService,
    private auth: AuthService
  ) {
    // this.userId = this.authService.userDetails().uid;
    this.userId = localStorage.getItem('userId');

  }

  ngOnInit(): void {
  }

  reset(): any {
    this.db.updateAt(`student/${this.userId}`, {
      playGame: []
    });
  }

}
